import React, { memo } from 'react'

const Label = ({ text, className }) => (
  <div className={`label ${className}`}>{text}</div>
)

export default memo(Label)
